import { Button, Heading, VStack } from '@chakra-ui/react'
import React from 'react'

const MaintenancePage = () => (
  <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
    <Heading size="lg">System maintenance is ongoing, please try again later </Heading>
    <Button colorScheme="blue" onClick={() => window.location.reload()}>
      Refresh
    </Button>
  </VStack>
)

export default MaintenancePage
